import { mutator } from "satcheljs";
import store from "../store/store";
import removeMessageAdList, { type REMOVE_MESSAGE_AD_LISTActionMessage, } from "../actions/removeMessageAdList";

/* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Please use a mutatorAction if action is defined in the same package */
const defaultExport: (actionMessage: REMOVE_MESSAGE_AD_LISTActionMessage) => void = mutator(removeMessageAdList, actionMessage => {
    store().inboxFolderShowAdCount = actionMessage.remainingShowAdCount;
    store().latestAdDeleteTime = Date.now();
});
export default defaultExport;
